import { useState } from "react";
import Layout from "../../layout/Layout";
import { useAuth } from "../../../components/context/AuthContext";
import { createKantarCapture } from "../../../api/sevkiyatCamera/SevkiyatCamApi";
import { customerApi } from "../../../utils/apiConfig";

function getBackendAssetUrl(fileUrl) {
  if (!fileUrl) return "";

  if (fileUrl.startsWith("http://") || fileUrl.startsWith("https://")) {
    return fileUrl;
  }

  const baseURL = customerApi?.defaults?.baseURL || "";

  const backendOrigin = baseURL.includes("/api/")
    ? baseURL.split("/api/")[0]
    : baseURL.replace(/\/+$/, "");

  return `${backendOrigin.replace(/\/+$/, "")}${
    fileUrl.startsWith("/") ? fileUrl : `/${fileUrl}`
  }`;
}

function KantarCapturePage() {
  const { user } = useAuth();

  const [irsaliyeNo, setIrsaliyeNo] = useState("");
  const [note, setNote] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  if (!user) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();

    const cleanIrsaliyeNo = irsaliyeNo.trim();

    if (!cleanIrsaliyeNo) {
      setErrorMessage("Plaka numarası zorunludur.");
      return;
    }

    try {
      setLoading(true);
      setErrorMessage("");
      setResult(null);

      const res = await createKantarCapture({
        irsaliyeNo: cleanIrsaliyeNo,
        note: note.trim(),
      });

      const responseData = res?.data;

      if (!responseData?.success) {
        throw new Error(
          responseData?.message || "Kantar kaydı oluşturulamadı."
        );
      }

      setResult(responseData.data);
      setIrsaliyeNo("");
      setNote("");
    } catch (error) {
      setErrorMessage(
        error?.response?.data?.message ||
          error?.message ||
          "Kantar fotoğrafı alınırken hata oluştu."
      );
    } finally {
      setLoading(false);
    }
  };

  const photos = Array.isArray(result?.photos) ? result.photos : [];
  const captureErrors = Array.isArray(result?.captureErrors)
    ? result.captureErrors
    : [];

  return (
    <Layout>
      <style>{`
        .kantar-capture-page,
        .kantar-capture-page * {
          box-sizing: border-box;
        }

        .kantar-capture-page {
          width: 100%;
          min-width: 0;
        }

        .kantar-capture-header,
        .kantar-result-header,
        .kantar-form,
        .kantar-form > div,
        .kantar-photo-grid,
        .kantar-photo-card {
          min-width: 0;
        }

        .kantar-form-control:focus {
          border-color: #1677ff !important;
          box-shadow: 0 0 0 3px rgba(22, 119, 255, 0.12);
        }

        .kantar-submit-button {
          transition: background-color 0.2s ease, transform 0.2s ease;
        }

        .kantar-submit-button:not(:disabled):active {
          transform: scale(0.99);
        }

        .kantar-photo-card {
          box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
        }

        .kantar-capture-errors-list {
          padding-left: 20px;
          overflow-wrap: anywhere;
        }

        @media (max-width: 768px) {
          .kantar-capture-page {
            padding: 20px !important;
            border-radius: 14px !important;
            min-height: auto !important;
            overflow: hidden;
          }

          .kantar-capture-header {
            flex-direction: column !important;
            align-items: stretch !important;
            gap: 14px !important;
            margin-bottom: 20px !important;
          }

          .kantar-capture-title {
            font-size: 23px !important;
            line-height: 1.25 !important;
            margin-top: 0 !important;
          }

          .kantar-capture-description {
            max-width: 100% !important;
            line-height: 1.55 !important;
          }

          .kantar-badge {
            align-self: flex-start;
          }

          .kantar-form {
            width: 100% !important;
            max-width: 100% !important;
          }

          .kantar-form-control {
            width: 100% !important;
            font-size: 16px !important;
          }

          .kantar-form-action {
            width: 100%;
            justify-content: stretch !important;
          }

          .kantar-submit-button {
            width: 100% !important;
            min-width: 0 !important;
            min-height: 48px;
            padding: 13px 16px !important;
          }

          .kantar-result-section {
            margin-top: 24px !important;
            padding-top: 20px !important;
          }

          .kantar-result-header {
            flex-wrap: wrap;
            align-items: flex-start !important;
            gap: 10px;
          }

          .kantar-result-title {
            font-size: 18px !important;
          }

          .kantar-photo-grid {
            grid-template-columns: minmax(0, 1fr) !important;
            gap: 14px !important;
          }

          .kantar-photo-image {
            height: auto !important;
            aspect-ratio: 16 / 9;
            object-fit: contain !important;
          }

          .kantar-alert {
            overflow-wrap: anywhere;
          }
        }

        @media (max-width: 480px) {
          .kantar-capture-page {
            padding: 16px !important;
            border-radius: 12px !important;
          }

          .kantar-capture-title {
            font-size: 21px !important;
          }

          .kantar-capture-description,
          .kantar-alert {
            font-size: 14px !important;
          }

          .kantar-badge {
            font-size: 12px !important;
            padding: 7px 10px !important;
          }

          .kantar-photo-card-content {
            padding: 12px !important;
          }
        }
      `}</style>

      <section
        className="kantar-capture-page"
        style={{
          flex: 1,
          maxWidth: "100%",
          background: "#fff",
          borderRadius: 18,
          boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
          padding: 32,
          minHeight: 420,
          boxSizing: "border-box",
        }}
      >
        <div
          className="kantar-capture-header"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: 16,
            marginBottom: 24,
          }}
        >
          <div>
            <h2
              className="kantar-capture-title"
              style={{
                fontWeight: 600,
                color: "#283049",
                marginBottom: 8,
                fontSize: 26,
              }}
            >
              Kantar Fotoğraf Kaydı
            </h2>

            <p
              className="kantar-capture-description"
              style={{
                color: "#6c757d",
                fontSize: 15,
                margin: 0,
                maxWidth: 650,
              }}
            >
              Plaka numarasını girip kantar kameralarından anlık fotoğraf
              alarak sevkiyat kontrol kaydı oluşturabilirsiniz.
            </p>
          </div>

          <span
            className="kantar-badge"
            style={{
              background: "#e8f0ff",
              color: "#1f5fbf",
              fontWeight: 600,
              fontSize: 13,
              padding: "8px 12px",
              borderRadius: 999,
              whiteSpace: "nowrap",
            }}
          >
            KANTAR
          </span>
        </div>

        {errorMessage && (
          <div
            className="kantar-alert"
            style={{
              background: "#fff1f0",
              border: "1px solid #ffccc7",
              color: "#a8071a",
              padding: "12px 14px",
              borderRadius: 10,
              marginBottom: 18,
              fontSize: 14,
            }}
          >
            {errorMessage}
          </div>
        )}

        {result && (
          <div
            className="kantar-alert"
            style={{
              background: "#f6ffed",
              border: "1px solid #b7eb8f",
              color: "#237804",
              padding: "12px 14px",
              borderRadius: 10,
              marginBottom: 18,
              fontSize: 14,
            }}
          >
            Kantar kaydı oluşturuldu. Plaka No:{" "}
            <strong>{result.irsaliyeNo}</strong>
          </div>
        )}

        <form
          className="kantar-form"
          onSubmit={handleSubmit}
          style={{
            display: "grid",
            gridTemplateColumns: "1fr",
            gap: 16,
            maxWidth: 680,
          }}
        >
          <div>
            <label
              style={{
                display: "block",
                color: "#283049",
                fontWeight: 600,
                marginBottom: 8,
                fontSize: 14,
              }}
            >
              Plaka No
            </label>

            <input
              className="kantar-form-control"
              value={irsaliyeNo}
              onChange={(e) => setIrsaliyeNo(e.target.value)}
              disabled={loading}
              placeholder="Plaka numarası giriniz"
              autoFocus
              inputMode="text"
              style={{
                width: "100%",
                height: 44,
                border: "1px solid #d9d9d9",
                borderRadius: 10,
                padding: "0 12px",
                fontSize: 15,
                outline: "none",
                boxSizing: "border-box",
              }}
            />
          </div>

          <div>
            <label
              style={{
                display: "block",
                color: "#283049",
                fontWeight: 600,
                marginBottom: 8,
                fontSize: 14,
              }}
            >
              Not
            </label>

            <textarea
              className="kantar-form-control"
              value={note}
              onChange={(e) => setNote(e.target.value)}
              disabled={loading}
              placeholder="Opsiyonel açıklama"
              rows={3}
              style={{
                width: "100%",
                border: "1px solid #d9d9d9",
                borderRadius: 10,
                padding: 12,
                fontSize: 15,
                resize: "vertical",
                outline: "none",
                boxSizing: "border-box",
                fontFamily: "inherit",
              }}
            />
          </div>

          <div
            className="kantar-form-action"
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: 4,
            }}
          >
            <button
              className="kantar-submit-button"
              type="submit"
              disabled={loading || !irsaliyeNo.trim()}
              style={{
                border: "none",
                background:
                  loading || !irsaliyeNo.trim() ? "#bfbfbf" : "#1677ff",
                color: "#fff",
                fontWeight: 600,
                borderRadius: 10,
                padding: "12px 18px",
                cursor:
                  loading || !irsaliyeNo.trim() ? "not-allowed" : "pointer",
                minWidth: 190,
              }}
            >
              {loading ? "Fotoğraf Alınıyor..." : "Fotoğraf Çek ve Kaydı Aç"}
            </button>
          </div>
        </form>

        {result && (
          <div
            className="kantar-result-section"
            style={{
              marginTop: 30,
              borderTop: "1px solid #f0f0f0",
              paddingTop: 24,
            }}
          >
            <div
              className="kantar-result-header"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 16,
              }}
            >
              <h3
                className="kantar-result-title"
                style={{
                  fontSize: 20,
                  color: "#283049",
                  margin: 0,
                  fontWeight: 600,
                }}
              >
                Çekilen Fotoğraflar
              </h3>

              <span
                style={{
                  background: "#f5f5f5",
                  color: "#595959",
                  fontSize: 13,
                  padding: "6px 10px",
                  borderRadius: 999,
                  whiteSpace: "nowrap",
                }}
              >
                {photos.length} Fotoğraf
              </span>
            </div>

            {photos.length > 0 ? (
              <div
                className="kantar-photo-grid"
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                  gap: 18,
                }}
              >
                {photos.map((photo) => (
                  <div
                    className="kantar-photo-card"
                    key={photo._id || photo.fileUrl}
                    style={{
                      border: "1px solid #f0f0f0",
                      borderRadius: 14,
                      overflow: "hidden",
                      background: "#fff",
                    }}
                  >
                    <img
                      className="kantar-photo-image"
                      src={getBackendAssetUrl(photo.fileUrl)}
                      alt={photo.cameraLabel || photo.cameraKey}
                      style={{
                        width: "100%",
                        height: 260,
                        objectFit: "cover",
                        display: "block",
                        background: "#f5f5f5",
                      }}
                    />

                    <div
                      className="kantar-photo-card-content"
                      style={{ padding: 14 }}
                    >
                      <div
                        style={{
                          color: "#283049",
                          fontWeight: 600,
                          marginBottom: 4,
                          overflowWrap: "anywhere",
                        }}
                      >
                        {photo.cameraLabel || photo.cameraKey}
                      </div>

                      <div
                        style={{
                          color: "#8c8c8c",
                          fontSize: 13,
                        }}
                      >
                        {photo.capturedAt
                          ? new Date(photo.capturedAt).toLocaleString("tr-TR")
                          : ""}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div
                className="kantar-alert"
                style={{
                  background: "#fffbe6",
                  border: "1px solid #ffe58f",
                  color: "#ad6800",
                  padding: "12px 14px",
                  borderRadius: 10,
                  fontSize: 14,
                }}
              >
                Fotoğraf bulunamadı.
              </div>
            )}

            {captureErrors.length > 0 && (
              <div
                className="kantar-alert"
                style={{
                  background: "#fffbe6",
                  border: "1px solid #ffe58f",
                  color: "#ad6800",
                  padding: "12px 14px",
                  borderRadius: 10,
                  fontSize: 14,
                  marginTop: 18,
                }}
              >
                <strong>Bazı kameralardan fotoğraf alınamadı:</strong>

                <ul
                  className="kantar-capture-errors-list"
                  style={{ marginBottom: 0, marginTop: 8 }}
                >
                  {captureErrors.map((item, index) => (
                    <li key={`${item.cameraKey}-${index}`}>
                      {item.cameraLabel}: {item.message}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        )}
      </section>
    </Layout>
  );
}

export default KantarCapturePage;
